import React from "react";
import {
  Dialog,
  DialogContent,
  CircularProgress,
  Typography,
  Stack,
  Backdrop,
  Fade,
  Box,
} from "@mui/material";

export default function ProcessingDialog({ loading }) {
  return (
    <Dialog
      open={loading}
      // 阻止按 Esc 键或点击背景关闭，提升加载时的交互体验
      disableEscapeKeyDown
      onClose={(event, reason) => {
        if (reason !== "backdropClick") return;
        // 这里可以添加点击背景的处理逻辑，通常加载时不做任何事
      }}
      // 使用 TransitionComponent 增加弹窗出现和消失的丝滑感
      TransitionComponent={Fade}
      transitionDuration={300}
      PaperProps={{
        sx: {
          borderRadius: 4,
          boxShadow: "0px 10px 40px rgba(0, 0, 0, 0.12)", // 更现代的柔和阴影
          p: 4,
          minWidth: 200,
          minHeight: 140,
        },
      }}
      // 自定义 Backdrop 样式，增加模糊感
      slots={{
        backdrop: Backdrop,
      }}
      slotProps={{
        backdrop: {
          timeout: 300,
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.3)", // 降低背景黑度，显得更轻盈
            backdropFilter: "blur(4px)", // 现代 UI 常用的毛玻璃效果
          },
        },
      }}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 5,
      }}
    >
      <DialogContent sx={{ p: 2 }}>
        <Stack
          direction='column'
          alignItems='center'
          spacing={2} // 使用 spacing 替代手动 margin
        >
          {/* 增加一个轻微的缩放动画让加载圈更生动 */}
          <CircularProgress
            size={40}
            thickness={4}
            sx={{
              animation: "pulse 1.5s ease-in-out infinite",
              "@keyframes pulse": {
                "0%": { transform: "scale(0.9)", opacity: 0.7 },
                "50%": { transform: "scale(1.1)", opacity: 1 },
                "100%": { transform: "scale(0.9)", opacity: 0.7 },
              },
            }}
          />
          <Typography
            variant='body1' // 稍微调大字号，增强可读性
            color='text.secondary'
            sx={{ fontWeight: 500, textAlign: "center" }}
          >
            Processing, please wait...
          </Typography>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
